import { atom } from "jotai";

export const headerMenuAtom = atom<boolean>(false)